import { Inputs } from '../types';

type TParams = {
  data: Inputs;
  state: {
    isRoomArea: boolean;
    isDoorsWindowsArea: boolean;
  };
};

export const getFormData = ({ data, state }: TParams): Inputs => {
  const formattedData = { ...data };
  if (state.isRoomArea) {
    formattedData.length = '';
    formattedData.width = '';
  } else if (!state.isRoomArea) {
    formattedData.area = '';
  }
  if (state.isDoorsWindowsArea) {
    formattedData.windows = '';
    formattedData.doors = '';
  } else if (!state.isDoorsWindowsArea) {
    formattedData.windowsFields = null;
    formattedData.doorsFields = null;
  }
  return formattedData;
};
